import { render, staticRenderFns } from "./EntrepreneurIntro.vue?vue&type=template&id=c2ddc798&scoped=true&"
import script from "./EntrepreneurIntro.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurIntro.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurIntro.vue?vue&type=style&index=0&id=c2ddc798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ddc798",
  null
  
)

export default component.exports